const getSelectedOption = (variant, option) => variant?.selectedOptions?.find((selectedOption) => selectedOption.name === option)?.value;

const filterImagesByVariant = (images, selectedVariant, product) => {
    if (!images?.length || !selectedVariant) return images;

    const _variants = product?.variants?.edges;
    const variantImages = [];
    const addedFabrics = [];
    _variants.forEach((variant) => {
        const fabric = getSelectedOption(variant.node, "Fabric").toLowerCase();
        const color = getSelectedOption(variant.node, "Color").toLowerCase();
        const fabricObject = {};
        const imagePosition = images.findIndex((image) => image.node.id === variant?.node?.image?.id || image.node.url === variant?.node?.image?.url?.url);

        if (!addedFabrics.includes(imagePosition)) {
            fabricObject.imageId = variant?.node?.image?.id;
            fabricObject.position = imagePosition;
            fabricObject.fabric = fabric;
            fabricObject.color = color;
            addedFabrics.push(imagePosition);
            variantImages.push(fabricObject);
        }
    });
    variantImages.sort((a, b) => a.position - b.position);

    const fabricVariantTitle = getSelectedOption(selectedVariant.node, "Fabric").toLowerCase();
    const colorVariantTitle = getSelectedOption(selectedVariant.node, "Color")?.toLowerCase();

    let selectedVariantIndex = variantImages.findIndex((image) => image.fabric === fabricVariantTitle && image.color === colorVariantTitle);
    if (selectedVariantIndex === -1) {
        selectedVariantIndex = variantImages.findIndex((image) => image.fabric === fabricVariantTitle);
    }
    const selectedImage = variantImages[selectedVariantIndex];
    if (!selectedImage) return images;

    const startIndex = selectedImage.position;
    const endIndex = variantImages[selectedVariantIndex + 1] ? variantImages[selectedVariantIndex + 1].position - 1 : images.length - 1;

    const alwaysInclude = { startIndex: 0, endIndex: variantImages[0].position - 1 };

    const _selectedImages = images.filter((image, index) => {
        if (index >= alwaysInclude.startIndex && index <= alwaysInclude.endIndex) return true;
        return index >= startIndex && index <= endIndex;
    });

    const temp = product?.image_version === "v2" ? [images[0], ..._selectedImages] : _selectedImages;
    if (selectedVariant?.node?.title === "Supreme / Gray" && product.image_version === "v2") {
        temp.shift();
    }

    return temp;
};

export default filterImagesByVariant;
